import React from 'react';

import { ScrollView } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';
import { withTypography } from 'ucl/components/text/Typography';

import { Box, BoxProps } from 'components/ui';
import { getDesignToken, primitive, spacing } from 'styles/constants';

/**
 * A wrapper for `ListItem` components.
 *
 * A list is built from its building blocks. See Storybook for example.
 */
export const List = ScrollView.withConfig(props => ({
  marginBottom: '4',
  ...props,
}));

/**
 * Displays a styled list item with borders and padding.
 */
export const ListItem = ({
  activeHighlight,
  isFirstChild,
  style,
  ...props
}: BoxProps & { activeHighlight?: boolean; isFirstChild?: boolean }) =>
  React.createElement(Box, {
    ...props,
    style: [
      styles.listItem,
      activeHighlight && styles.activeListItem,
      isFirstChild && styles.firstListItem,
      style,
    ],
  });

/**
 * Content spacing for a List item.
 *
 * This component exists if the entire contend needs to
 * be replaced for customization.
 */
export const ListItemContent = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.listItemContent, style] });

/**
 * Styled title for ListItem content
 */
export const ListItemTitle = withTypography({
  fontFamily: 'heading',
  fontSize: 'md',
  color: primitive.$bbqBrown,
  bold: true,
  style: { width: '100%' },
});

/**
 * Styled subtext for a ListItem's content
 */
export const ListItemSubtext = withTypography({ variant: 'copyTwo', color: primitive.$bbqBrown });

const styles = StyleSheet.create({
  listItem: {
    borderBottomColor: primitive.$greyFour,
    borderBottomWidth: 1,
  },
  activeListItem: { backgroundColor: getDesignToken('background-default') },
  firstListItem: { borderTopWidth: 1 },
  listItemContent: { paddingHorizontal: 96, paddingVertical: spacing.$4 },
});
